import { useQuery } from '@tanstack/react-query';

import type { IConfig } from '~/config/types';
import { HASH as MAKO_HASH } from '~/config/mako/hash.gen.ts';
import { HASH as N12_HASH } from '~/config/n12/hash.gen.ts';
import { ClientName } from '~/constants';

interface Params {
  clientName: (typeof ClientName)[keyof typeof ClientName];
}

const hashMap: Record<string, string> = {
  [ClientName.MAKO]: MAKO_HASH,
  [ClientName.N12]: N12_HASH,
};

export function useConfig({ clientName }: Params) {
  return useQuery({
    queryKey: ['config', clientName],
    queryFn: async () => {
      const res = await fetch(`/theme/${clientName}/config-${hashMap[clientName] ?? ''}.json`);

      if (!res.ok) {
        throw new Error(`Failed to fetch config for clientId "${clientName}": ${res.statusText}`);
      }

      return res.json() as Promise<IConfig>;
    },
  });
}
